export default __webpack_public_path__ + "static/media/k7.d7487e2f.jpg";